import script from "./SessionSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionSearch.vue?vue&type=script&setup=true&lang=js"

import "./SessionSearch.vue?vue&type=style&index=0&id=004e972d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004e972d"]])

export default __exports__